import type { Components } from "@mui/material/styles";

import type { Theme } from "../types";

export const MuiLink = {
	defaultProps: { underline: "none" },
	styleOverrides: {
		root: ({ theme }) => ({
			transition: theme.transitions.create(["color"], {
				duration: theme.transitions.duration.shortest,
			}),
			"&:hover": {
				color: theme.palette.primary.main,
				textDecoration: "none",
			},
		}),
	},
} satisfies Components<Theme>["MuiLink"];
